/* Russian copy for the admin web. Kept inline (not JSON) so TypeScript
   catches missing keys at compile time via the `Resources` type below. */

export const ru = {
  common: {
    app_name: 'Twin Turbo Admin',
    sign_out: 'Выйти',
    account: 'Аккаунт',
    loading: 'Загрузка…',
    error_generic: 'Что-то пошло не так. Попробуйте ещё раз.',
    create: 'Создать',
    edit: 'Изменить',
    delete: 'Удалить',
    save: 'Сохранить',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    confirm_delete: 'Удалить',
    actions: 'Действия',
    empty: 'Пусто.',
    copy: 'Копировать',
    copied: 'Скопировано',
    close: 'Закрыть',
  },
  notifications: {
    enable: 'Включить уведомления',
    disable: 'Выключить уведомления',
    blocked: 'Уведомления заблокированы в браузере',
  },
  auth: {
    login_title: 'Вход',
    login_subtitle: 'Диспетчеры и кабинеты клиентов',
    username: 'Логин',
    password: 'Пароль',
    otp_label: 'Код 2FA',
    otp_hint: 'Шестизначный код из приложения-аутентификатора',
    remember_me: 'Запомнить меня',
    submit: 'Войти',
    submit_with_otp: 'Подтвердить',
    error_invalid_credentials: 'Неверный логин или пароль.',
    error_rate_limited: 'Слишком много попыток. Подождите 15 минут.',
    error_account_locked: 'Аккаунт заблокирован. Обратитесь к администратору.',
    error_otp_required: 'Введите код двухфакторной аутентификации.',
    error_otp_invalid: 'Неверный код 2FA.',
    error_network: 'Нет связи с сервером.',
  },
  nav: {
    dashboard: 'Главная',
    orders: 'Заказы',
    map: 'Карта',
    operators: 'Операторы',
    providers: 'Провайдеры',
    clients: 'Клиенты',
    catalog: 'Справочники',
    pricing: 'Цены',
    rules: 'Правила',
    refill_requests: 'Дозаправки',
    chat: 'Чат',
    reports: 'Отчёты',
  },
  layout: {
    sidebar_label: 'Главная навигация',
    section_main: 'Основное',
    section_admin: 'Администрирование',
    section_other: 'Прочее',
  },
  dashboard: {
    title: 'Главная',
    placeholder: 'Список заказов — в разделе «Заказы», карта операторов — в разделе «Карта».',
    subtitle: 'Оперативная сводка по смене',
    kpi_active: 'Активные заказы',
    kpi_problem: 'Проблемные',
    kpi_online: 'Операторы онлайн',
    kpi_providers: 'Провайдеры',
    kpi_total: 'всего',
    kpi_of: 'из',
    recent_orders: 'Последние заказы',
  },
  orders: {
    title: 'Заказы',
    col_ref: 'Заказ',
    col_car: 'Госномер',
    col_state: 'Статус',
    col_operator: 'Оператор',
    col_actions: 'Действия',
    filter_state: 'Статус:',
    filter_operator: 'Оператор:',
    filter_all: 'Все',
    total: 'Всего: {{n}}',
    empty: 'Заказов не найдено.',
    prev: 'Назад',
    next: 'Вперёд',
    assign: 'Назначить',
    assign_select: 'Выбор оператора',
    assign_pick: '— оператор —',
    cancel: 'Отменить',
    mark_error: 'Проблемный',
    approval_in_chat: 'В чат',
    approve_start: 'Одобрить старт',
    reject_start: 'Отклонить старт',
    approve_completion: 'Одобрить завершение',
    reject_completion: 'Отклонить завершение',
    history: 'История статусов',
    fuel_amount: 'Литры',
    total_price: 'Сумма',
    coords: 'Координаты',
    invoice: 'Расчёт',
    invoice_fuel: 'Топливо',
    invoice_total: 'Итого',
    videos: 'Видео заправки',
    videos_empty: 'Видео пока нет.',
    video_watch: 'Смотреть',
    video_download: 'Скачать',
    video_share: 'Копировать ссылку',
    video_share_copied: 'Ссылка скопирована',
  },
  map: {
    title: 'Карта',
    active_orders: 'Активных заказов: {{n}}',
    online_operators: 'Операторов на линии: {{n}}',
    unavailable: 'Карта недоступна (нет ключа Yandex JS API или ошибка загрузки).',
  },
  catalog: {
    title: 'Справочники',
    fuel_types: 'Виды топлива',
    departments: 'Подразделения',
    fuel_stations: 'АЗС',
    refuel_cars: 'Бензовозы',
    equipment: 'Оборудование',
    administrative_levels: 'Регионы',
    mac: 'MAC',
    status: 'Статус',
    assigned_car: 'Машина',
    pick_car: 'Выберите бензовоз',
    equipment_status: {
      ACTIVE: 'На машине',
      SPARE: 'На складе',
      IN_SERVICE: 'На сервисе',
    },
    equipment_action: {
      assign: 'Поставить на машину',
      unassign: 'Снять',
      service: 'На сервис',
    },
    code: 'Код',
    name: 'Название',
    base_price: 'Базовая цена',
    color: 'Цвет',
    active: 'Активен',
    external_id: 'Внешний ID',
    external_id_kmazs: 'Код в КМАЗС (mpfind/mpadd)',
    fuel_type: 'Топливо',
    lat: 'Широта',
    lon: 'Долгота',
    plate_number: 'Госномер',
    capacity_liters: 'Ёмкость, л',
    admin_level: 'Уровень',
    parent: 'Родитель',
    region: 'Регион',
    decimal_hint: 'Дробное число, точка как разделитель (например, 1.50).',
  },
  operators: {
    title: 'Операторы',
    username: 'Логин',
    password: 'Пароль',
    password_hint: 'Минимум 8 символов; нельзя поменять после создания.',
    first_name: 'Имя',
    last_name: 'Фамилия',
    name: 'Имя',
    phone: 'Телефон',
    department: 'Подразделение',
    region: 'Регион',
    refuel_car: 'Бензовоз',
    rule: 'Правило',
    can_take_self: 'Может брать сам',
    show_colors: 'Цветовая разметка',
    refuel_key: 'Ключ заправки',
    refuel_key_hint: '16 HEX-символов (iButton/Mifare/EM-Marine) или 19 цифр RFID (PetroPoint/ORPAK, ведущие нули — «+»).',
    refuel_key_generate: 'Сгенерировать',
    refuel_key_copy: 'Копировать',
    online: 'Онлайн',
    active_orders: 'Заказы',
    providers: 'Провайдеры',
    providers_title: 'Видимость по провайдерам',
    providers_hint: 'Без выбора оператор видит все каршеринги. Выберите — ограничить.',
  },
  providers: {
    title: 'Провайдеры',
    code: 'Код',
    name: 'Название',
    integration_url: 'URL интеграции',
    default_department: 'Подразделение по умолчанию',
    active: 'Активен',
    rotate_token: 'Выпустить токен',
    rotate_intro: 'Выпуск нового токена для {{provider}}. Прежние токены продолжают работать до явного отзыва.',
    token_name: 'Метка токена',
    token_name_placeholder: 'production / staging / smoke',
    rotate_confirm: 'Выпустить',
    token_issued: 'Новый токен',
    show_once_warning: 'Этот токен показывается один раз. Скопируйте и сохраните его сейчас — после закрытия окна восстановить нельзя.',
  },
  pricing: {
    title: 'Цены',
    set_override: 'Новый прайс',
    edit_override: 'Изменить прайс',
    region: 'Регион',
    provider: 'Провайдер',
    fuel: 'Топливо',
    unit_price: 'Цена за литр',
    services: 'Услуги',
    fuel_section: 'Топливо',
    delivery: 'Доставка',
    surcharges: 'Доплаты (по запросу)',
    surcharges_toggle_show: 'Показать доплаты',
    surcharges_toggle_hide: 'Скрыть доплаты',
    rate: 'Ставка',
    billing_unit: 'Единица',
    billing_per_litre: 'За литр',
    billing_per_order: 'За выезд',
    billing_fixed: 'Фикс',
    unit_short_per_litre: '₽/л',
    unit_short_per_order: '₽/выезд',
    unit_short_fixed: '₽',
    threshold: 'Порог, л',
    threshold_suffix: 'при < {{n}} л',
    history: 'История',
    empty: 'Прайсов пока нет.',
    active: 'Активно',
    closed: 'Закрыто',
    triple_required: 'Выберите регион, провайдера и топливо.',
    none: '—',
    preview_liters: 'Литров для расчёта',
    preview_total: 'Расчёт за {{n}} л',
    preview_plus_surcharges: '+ доплаты по запросу',
    surcharges_count: '{{n}} доплат',
    kind_fuel: 'Топливо',
    kind_service: 'Услуга',
  },
  chat: {
    title: 'Чат',
    new_message_title: 'Новое сообщение в чате',
    new_approval_title: 'Требуется одобрение заправки',
    operators_label: 'Список операторов',
    no_operators: 'Операторов нет.',
    pick_operator: 'Выберите оператора слева.',
    empty: 'Сообщений ещё нет.',
    message_input: 'Сообщение',
    message_placeholder: 'Сообщение оператору…',
    send: 'Отправить',
    read: 'прочитано',
    read_mark: '✓✓',
    unread: '{{count}} непрочитанных',
    typing: 'оператор печатает…',
    attach_file: 'Прикрепить фото',
    record: 'Записать голосовое',
    stop_record: 'Стоп',
    cancel_record: 'Отменить запись',
    recording: 'Идёт запись…',
    remove_attachment: 'Убрать вложение',
    attachment_loading: 'Загрузка вложения…',
    attachment_failed: 'Не удалось загрузить вложение',
    image_alt: 'Вложение-изображение',
    download_file: 'Скачать файл',
    mic_error: 'Нет доступа к микрофону',
    approval_title: 'Запрос подтверждения',
    open_order: 'Открыть заказ',
    approve: 'Одобрить',
    reject: 'Отклонить',
    approved: 'Одобрено',
    rejected: 'Отклонено',
  },
  refill: {
    title: 'Заявки на дозаправку',
    operator: 'Оператор',
    requested_at: 'Запрошена',
    status: 'Статус',
    decline_reason: 'Причина отказа',
    fuel_station: 'АЗС',
    station_optional: 'необязательно',
    approve: 'Одобрить',
    decline: 'Отклонить',
    approve_title: 'Одобрить заявку',
    decline_title: 'Отклонить заявку',
    empty: 'Заявок нет.',
    status_PENDING: 'Ожидают',
    status_APPROVED: 'Одобренные',
    status_DECLINED: 'Отклонённые',
    status_COMPLETED: 'Выполненные',
    status_CANCELLED: 'Отменённые',
  },
  reports: {
    title: 'Отчёты',
    from: 'С даты',
    to: 'По дату',
    download: 'Скачать XLSX',
    completed_orders: 'Завершённые заказы',
    operators_summary: 'Сводка по операторам',
    providers_summary: 'Сводка по провайдерам',
    last_size: 'Размер файла: {{bytes}} байт.',
  },
  rules: {
    title: 'Правила фильтрации заказов',
    create: 'Создать правило',
    name: 'Имя правила',
    combine_mode: 'Объединение условий',
    lines: 'Условий',
    empty: 'Правила не настроены.',
    add_line: 'Добавить условие',
    property: 'Поле',
    operator: 'Оператор',
    value: 'Значение',
    value_placeholder: 'UUID, число или CSV-список (для IN).',
    name_required: 'Имя правила обязательно.',
  },
  clients: {
    title: 'Клиенты',
    subtitle: 'Кабинеты каршерингов — доступ к своим завершённым заправкам',
    create: 'Создать кабинет',
    username: 'Логин',
    password: 'Пароль',
    password_hint: 'Минимум 8 символов.',
    password_auto_hint: 'Сгенерирован автоматически. Скопируйте и передайте клиенту.',
    regenerate: 'Сгенерировать заново',
    company: 'Компания',
    company_placeholder: 'BelkaCar',
    company_select: 'Выберите компанию',
    providers: 'Провайдеры',
    providers_required:
      'Выберите хотя бы одного провайдера — иначе кабинет не увидит ни одной заправки.',
    regions: 'Регионы',
    regions_hint: 'Пусто — все регионы.',
    departments: 'Подразделения',
    departments_hint: 'Пусто — все подразделения.',
    fuel_types: 'Топливо',
    fuel_hint: 'Пусто — все виды топлива.',
    can_view_media: 'Видит видео заправок',
    can_export: 'Может строить отчёты (XLSX/PDF)',
    can_view_pricing: 'Видит цены',
    completed_only: 'Только завершённые заказы',
    date_from: 'Видит заказы с даты',
    date_to: 'Видит заказы по дату',
    dates_hint: 'Пусто — без ограничения по датам (видит все свои заправки).',
    created_title: 'Кабинет создан',
    created_hint:
      'Передайте клиенту логин и пароль. Вход — по тому же адресу, что и админка. Пароль показывается один раз.',
    copy_credentials: 'Копировать логин и пароль',
    review_hint: 'Проверьте настройки и создайте кабинет.',
    step: 'Шаг {{n}} из {{total}}',
    next: 'Далее',
    back: 'Назад',
    finish: 'Создать кабинет',
    step_access: 'Доступ',
    step_providers: 'Провайдеры',
    step_regions: 'Регионы',
    step_scope: 'Подразделения и топливо',
    step_permissions: 'Права',
    step_review: 'Проверка',
    err_username: 'Логин — минимум 3 символа.',
    err_password: 'Пароль — минимум 8 символов.',
    err_providers: 'Выберите хотя бы одного провайдера.',
    all: 'все',
    none: 'нет',
    yes: 'да',
    no: 'нет',
    col_provider_scope: 'Провайдеры',
    col_permissions: 'Права',
    col_active: 'Активен',
    perm_media: 'видео',
    perm_export: 'отчёты',
    perm_pricing: 'цены',
    edit_title: 'Кабинет клиента',
    password_reset: 'Новый пароль (пусто — без изменений)',
    scope_section: 'Область видимости',
    flags_section: 'Права и окно дат',
  },
  client_cabinet: {
    brand: 'Кабинет клиента',
    title: 'Заправки',
    subtitle: 'Ваши завершённые заправки',
    filter_from: 'С даты',
    filter_to: 'По дату',
    filter_car: 'Гос. номер',
    apply: 'Применить',
    reset: 'Сбросить',
    export_xlsx: 'Экспорт XLSX',
    export_pdf: 'Экспорт PDF',
    col_datetime: 'Дата и время',
    col_truck: 'Бензовоз',
    col_driver: 'Водитель',
    col_car: 'Авто',
    col_make: 'Марка техники',
    col_city: 'Город',
    col_fuel: 'ГСМ',
    col_liters: 'Кол-во, л',
    col_price: 'Цена',
    col_fuel_sum: 'Сумма',
    col_delivery: 'Доставка',
    col_services: 'Сумма услуг',
    col_total: 'Сумма итого',
    col_external: 'Внешний ID',
    col_state: 'Статус',
    col_unit_price: 'Цена/л',
    col_completed: 'Завершён',
    col_video: 'Видео',
    watch: 'Смотреть',
    videos_title: 'Видео заправки',
    no_videos: 'Видео нет.',
    download: 'Скачать',
    loading_video: 'Загрузка видео…',
    video_failed: 'Не удалось загрузить видео.',
    total_count: 'Всего: {{n}}',
    prev: 'Назад',
    next: 'Вперёд',
    empty: 'Заправок нет.',
    state_completed: 'Завершён',
  },
} as const;

export type Resources = typeof ru;
